// TODO: move this component to the ZUI library, for now it is just a copy based from this component: https://github.com/zenbusiness/business-operations-ui/tree/cb7ce783d57e31da55a73c69d9b5f9bbccdacb0e/src/components/ClientForms/PhoneNumberField
import { useCallback } from 'react';

import PropTypes from 'prop-types';
import PhoneInput from 'react-phone-number-input/input';

import Field from '#client/components/Field';

export const PHONE_NUMBER_MAX_LENGTH = 16;

function PhoneTextField({ error, onChange, value, ...field }) {
  const handleChange = useCallback(
    (newValue) => {
      // Ensure empty string is passed when clearing the input
      onChange(newValue || '');
    },
    [onChange]
  );

  return (
    <Field
      {...field}
      error={error}
      InputProps={{
        inputComponent: PhoneInput,
        inputProps: {
          country: 'US',
          autoComplete: 'tel',
          inputMode: 'tel',
          maxLength: PHONE_NUMBER_MAX_LENGTH,
          'data-testid': 'phone-number-field'
        }
      }}
      type="tel"
      value={value}
      onChange={handleChange}
    />
  );
}

PhoneTextField.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string
  }),
  inputProps: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string
};

export default PhoneTextField;
